import { useLazyQuery, gql } from "@apollo/client"
import {
  ACTION_FIELDS,
  ACTION_COMMENT_CREATED_SUBSCRIPTION,
  ACTION_UPDATED_SUBSCRIPTION,
  ACTION_DELETED_SUBSCRIPTION,
  ACTION_CREATED_SUBSCRIPTION,
  actionCreatedSubscriptionUpdateQuery,
  actionDeletedSubscriptionUpdateQuery,
  actionCommentCreatedSubscriptionUpdateQuery,
} from "./useQueryActions"

const ACTION_QUERY = gql`
  ${ACTION_FIELDS}
  query Action($id: ID!) {
    action(id: $id) {
      ...ActionFields
    }
  }
`

const subscribe = (result) => () =>
  [
    result.subscribeToMore({
      document: ACTION_CREATED_SUBSCRIPTION,
      updateQuery: actionCreatedSubscriptionUpdateQuery,
      onError: (err) => console.log("[useQueryActions][ACTION_CREATED_SUBSCRIPTION]", err),
    }),
    result.subscribeToMore({
      document: ACTION_UPDATED_SUBSCRIPTION,
      onError: (err) => console.log("[useLazyQueryAction][ACTION_UPDATED_SUBSCRIPTION]", err),
    }),
    result.subscribeToMore({
      document: ACTION_DELETED_SUBSCRIPTION,
      updateQuery: actionDeletedSubscriptionUpdateQuery,
      onError: (err) => console.log("[useLazyQueryAction][ACTION_DELETED_SUBSCRIPTION]", err),
    }),
    result.subscribeToMore({
      document: ACTION_COMMENT_CREATED_SUBSCRIPTION,
      updateQuery: actionCommentCreatedSubscriptionUpdateQuery,
      onError: (err) => console.log("[useLazyQueryAction][COMMENT_CREATED_SUBSCRIPTION]", err),
    }),
  ]

const useLazyQueryAction = () => {
  const [loadAction, result] = useLazyQuery(ACTION_QUERY, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
  })

  return [
    loadAction,
    {
      ...result,
      subscribe: subscribe(result),
    },
  ]
}

export { useLazyQueryAction, ACTION_QUERY }
